import React, { useState, useEffect } from "react";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import {
  Modal,
  ModalBody,
  Form,
} from "reactstrap";
import {
  Block,
  BlockHead,
  BlockBetween,
  BlockHeadContent,
  BlockTitle,
  BlockDes,
  Icon,
  Button,
  DataTable,
  DataTableBody,
  DataTableHead,
  DataTableRow,
  DataTableItem,
  PaginationComponent,
  UserAvatar,
  RSelect,
  Col,
} from "../../../components/Component";
import { useForm } from "react-hook-form";
import { api } from "../../../utils/api";
import { findUpper } from "../../../utils/Utils";
import { toast } from "react-toastify";
import { Badge, Spinner, Input } from "reactstrap";
import { PreviewCard } from "../../../components/Component";

const UserSiteAssignment = () => {
  const [sm, updateSm] = useState(false);
  const [modal, setModal] = useState({ assign: false });
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedSite, setSelectedSite] = useState(null);
  const [users, setUsers] = useState([]);
  const [sites, setSites] = useState([]);
  const [statistics, setStatistics] = useState(null);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [formData, setFormData] = useState({
    site_ids: [],
  });

  const { errors, register, handleSubmit } = useForm();

  useEffect(() => {
    loadData();
    loadSites();
    loadStatistics();
  }, [selectedSite, currentPage, searchText]);

  const loadData = async () => {
    setLoading(true);
    try {
      const params = { page: currentPage, per_page: itemPerPage };
      if (searchText) params.search = searchText;
      if (selectedSite) params.site_id = selectedSite;
      
      const response = await api.getUserSites(params);
      if (response.data) {
        setUsers(response.data);
        setTotalItems(response.total || 0);
      } else {
        setUsers(response);
        setTotalItems(response.length || 0);
      }
    } catch (error) {
      toast.error("Erreur lors du chargement des données");
      setUsers([]);
      setTotalItems(0);
    } finally {
      setLoading(false);
    }
  };

  const loadSites = async () => {
    try {
      const response = await api.getSites();
      setSites(response.data || response || []);
    } catch (error) {
      // Ignorer l'erreur
    }
  };

  const loadStatistics = async () => {
    try {
      const response = await api.getUserSitesStatistics();
      setStatistics(response);
    } catch (error) {
      // Ignorer l'erreur
    }
  };

  const onAssignClick = (user) => {
    setSelectedUser(user);
    setFormData({
      site_ids: user.sites ? user.sites.map((s) => s.id) : [],
    });
    setModal({ assign: true });
  };

  const onAssignSubmit = async () => {
    try {
      await api.assignUserSites(selectedUser.id, formData.site_ids);
      toast.success("Sites assignés avec succès");
      loadData();
      loadStatistics();
      setModal({ assign: false });
      setSelectedUser(null);
    } catch (error) {
      toast.error(error.message || "Erreur lors de l'assignation");
    }
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const getRoleBadge = (roles) => {
    if (!roles || roles.length === 0) {
      return <Badge color="secondary">Non défini</Badge>;
    }
    const roleName = roles[0].name;
    const roleColors = {
      'Employé': 'info',
      'Superviseur': 'primary',
      'Responsable HSE': 'success',
      'Manager': 'warning',
      'Manager / Direction': 'warning',
      'Administrateur système': 'danger',
    };
    return <Badge color={roleColors[roleName] || 'secondary'}>{roleName}</Badge>;
  };

  return (
    <React.Fragment>
      <Head title="Attribution par site" />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Attribution par site</BlockTitle>
              <BlockDes className="text-soft">Gérez les attributions des utilisateurs aux sites</BlockDes>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand me-n1 ${sm ? "active" : ""}`}
                  onClick={() => updateSm(!sm)}
                >
                  <Icon name="menu-alt-r"></Icon>
                </Button>
                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    {/* Les outils seront dans les tabs */}
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        {statistics && (
          <Block>
            <div className="row g-gs">
              <Col md="3">
                <div className="card border-0 bg-light">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">
                        <span className="sub-text d-block">Total utilisateurs</span>
                        <h4 className="mb-0">{statistics.total_users || 0}</h4>
                      </div>
                      <Icon name="users" className="text-primary" style={{ fontSize: "2rem" }}></Icon>
                    </div>
                  </div>
                </div>
              </Col>
              <Col md="3">
                <div className="card border-0 bg-light">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">
                        <span className="sub-text d-block">Avec sites</span>
                        <h4 className="mb-0">{statistics.users_with_sites || 0}</h4>
                      </div>
                      <Icon name="check-circle" className="text-success" style={{ fontSize: "2rem" }}></Icon>
                    </div>
                  </div>
                </div>
              </Col>
              <Col md="3">
                <div className="card border-0 bg-light">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">
                        <span className="sub-text d-block">Sans sites</span>
                        <h4 className="mb-0">{statistics.users_without_sites || 0}</h4>
                      </div>
                      <Icon name="alert-circle" className="text-warning" style={{ fontSize: "2rem" }}></Icon>
                    </div>
                  </div>
                </div>
              </Col>
              <Col md="3">
                <div className="card border-0 bg-light">
                  <div className="card-body">
                    <div className="d-flex align-items-center">
                      <div className="flex-grow-1">
                        <span className="sub-text d-block">Total sites</span>
                        <h4 className="mb-0">{statistics.sites?.length || 0}</h4>
                      </div>
                      <Icon name="location" className="text-info" style={{ fontSize: "2rem" }}></Icon>
                    </div>
                  </div>
                </div>
              </Col>
            </div>
          </Block>
        )}

        <Block>
          <BlockHead>
            <BlockBetween>
              <BlockHeadContent>
                <ul className="nk-block-tools g-3">
                  <li>
                    <div className="form-control-wrap">
                      <div className="form-icon form-icon-left">
                        <Icon name="search"></Icon>
                      </div>
                      <Input
                        type="text"
                        className="form-control"
                        placeholder="Rechercher un utilisateur..."
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                          setCurrentPage(1);
                        }}
                        style={{ minWidth: "250px" }}
                      />
                    </div>
                  </li>
                  <li>
                    <div style={{ minWidth: "280px", width: "280px" }}>
                      <RSelect
                        options={[
                          { value: null, label: "Tous les sites" },
                          ...sites.map((s) => ({ value: s.id, label: s.name })),
                        ]}
                        value={
                          selectedSite
                            ? { value: selectedSite, label: sites.find((s) => s.id === selectedSite)?.name }
                            : { value: null, label: "Tous les sites" }
                        }
                        onChange={(e) => {
                          setSelectedSite(e.value);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </li>
                </ul>
              </BlockHeadContent>
            </BlockBetween>
          </BlockHead>

          <DataTable className="card-stretch">
            <DataTableBody>
              <DataTableHead className="nk-tb-item nk-tb-head">
                <DataTableRow>
                  <span className="sub-text">Utilisateur</span>
                </DataTableRow>
                <DataTableRow>
                  <span className="sub-text">Rôle</span>
                </DataTableRow>
                <DataTableRow>
                  <span className="sub-text">Sites</span>
                </DataTableRow>
                <DataTableRow className="nk-tb-col-tools text-end"></DataTableRow>
              </DataTableHead>
              {loading ? (
                <DataTableItem>
                  <DataTableRow>
                    <DataTableItem colSpan={4} className="text-center">
                      <Spinner color="primary" />
                    </DataTableItem>
                  </DataTableRow>
                </DataTableItem>
              ) : users.length === 0 ? (
                <DataTableItem>
                  <DataTableRow>
                    <DataTableItem colSpan={4} className="text-center">
                      <PreviewCard>
                        <div className="text-center py-4">
                          <span className="text-soft">Aucun utilisateur trouvé</span>
                        </div>
                      </PreviewCard>
                    </DataTableItem>
                  </DataTableRow>
                </DataTableItem>
              ) : (
                users.map((user) => (
                  <DataTableItem key={user.id}>
                    <DataTableRow>
                      <div className="d-flex align-items-center">
                        <UserAvatar
                          className="me-2"
                          size="sm"
                          theme="blue"
                          text={findUpper(`${user.first_name || ""} ${user.last_name || ""}`.trim() || "N/A")}
                        />
                        <div>
                          <span className="tb-lead">{`${user.first_name || ""} ${user.last_name || ""}`.trim() || "N/A"}</span>
                          <span className="sub-text d-block">{user.email || ""}</span>
                        </div>
                      </div>
                    </DataTableRow>
                    <DataTableRow>{getRoleBadge(user.roles)}</DataTableRow>
                    <DataTableRow>
                      {user.sites && user.sites.length > 0 ? (
                        <div className="d-flex flex-wrap gap-1">
                          {user.sites.map((site) => (
                            <Badge key={site.id} color="info" className="badge-dim">
                              {site.name}
                            </Badge>
                          ))}
                        </div>
                      ) : (
                        <span className="text-soft">Aucun site</span>
                      )}
                    </DataTableRow>
                    <DataTableRow className="nk-tb-col-tools">
                      <ul className="nk-tb-actions gx-1">
                        <li>
                          <button
                            className="btn btn-trigger btn-icon"
                            onClick={() => onAssignClick(user)}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Assigner des sites"
                          >
                            <Icon name="edit"></Icon>
                          </button>
                        </li>
                      </ul>
                    </DataTableRow>
                  </DataTableItem>
                ))
              )}
            </DataTableBody>
            <div className="card-inner">
              {totalItems > 0 && (
                <PaginationComponent
                  itemPerPage={itemPerPage}
                  totalItems={totalItems}
                  paginate={paginate}
                  currentPage={currentPage}
                />
              )}
            </div>
          </DataTable>
        </Block>

        {/* Modal Assign Sites */}
        <Modal isOpen={modal.assign} toggle={() => { setModal({ assign: false }); setSelectedUser(null); }} className="modal-dialog-centered" size="lg">
          <div className="modal-header">
            <h5 className="modal-title">Assigner des sites à {selectedUser ? `${selectedUser.first_name} ${selectedUser.last_name}` : ""}</h5>
            <button className="close" onClick={() => { setModal({ assign: false }); setSelectedUser(null); }}>
              <Icon name="cross"></Icon>
            </button>
          </div>
          <ModalBody>
            <Form className="is-alter" onSubmit={handleSubmit(onAssignSubmit)}>
              <div className="form-group">
                <label className="form-label">Sites *</label>
                <RSelect
                  isMulti
                  options={sites.map((site) => ({ value: site.id, label: site.name }))}
                  value={formData.site_ids.map((id) => {
                    const site = sites.find((s) => s.id === id);
                    return site ? { value: site.id, label: site.name } : null;
                  }).filter(Boolean)}
                  onChange={(selected) => {
                    setFormData({
                      ...formData,
                      site_ids: selected ? selected.map((opt) => opt.value) : [],
                    });
                  }}
                  placeholder="Sélectionner les sites"
                />
              </div>
              <div className="form-group text-end">
                <Button color="light" onClick={() => { setModal({ assign: false }); setSelectedUser(null); }} className="me-2">
                  Annuler
                </Button>
                <Button color="primary" type="submit">
                  Assigner
                </Button>
              </div>
            </Form>
          </ModalBody>
        </Modal>
      </Content>
    </React.Fragment>
  );
};

export default UserSiteAssignment;

